import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { DEALS_API_PATH } from "@/modules/Deals/constants";
import { PROMOS_AND_DEALS } from "@/modules/Deals/constants";
class DealsService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getOrganizationPromos(
    organizationId: string,
  ): Promise<ICoreResponse<ICoreResponse<PROMOS_AND_DEALS>>> {
    return this.restClient.get(
      DEALS_API_PATH.GET_ORGANIZATION_DEALS_AND_PROMOS(organizationId),
    );
  }
}

export default DealsService;
